import React, { useEffect, useState } from "react";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import coupon_frame from "../../Assets/Images/icons/coupon_frame.png"
import { FaIndianRupeeSign } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa6";
// Coupon_card

const CouponCard = ({
  item,
  couponId,
  showDescription,
  couponLoadingId,
  handleApply,
  handleRemove,
  setCouponId,
  setShowDescription,
  viewOnly = false, // browse-only: no Apply/Remove, nothing dimmed
}) => {
  return (
    <div key={item.coupons_id} className="mt-2 mb-2 coupon_card_top">
      <div   className={`  rounded-4 coupon_card d-flex ${!viewOnly && item.available_status == 0 ? "opacity-40" : "" }`}   >
        <img src={coupon_frame} className="coupon_frame" alt="coupon" />

        <div className="col-10 ms-1 p-2">
          {/* Coupon header */}
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h5 className="p-0 m-0 fs-14 ff-poppins-semiBold">
                {item?.coupons_code}
              </h5>
              <h6 className="p-0 m-0 fs-12 ff-poppins-semiBold primary-text">
                {item.discount_type == 1 && <span className="rupeeIcon">₹</span>}{item.discount}{item.discount_type == 2 && "%"} {" "}Discount
              </h6>
            </div>

            {viewOnly ? null : item.applied_status == 1 ? (
              <button
                className="apply_btn bg-danger ff-poppins-medium fs-12 mt-2"
                onClick={() => handleRemove(item)}
              >
                {couponLoadingId == item.coupons_id && couponLoadingId != null ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Loading...</span>
                  </>
                ) : (
                  "Remove"
                )}
              </button>
            ) : (
              <button
                className="apply_btn primary-bg ff-poppins-medium fs-12 mt-2"
                onClick={() => {
                  if (item.available_status == 1) {
                    handleApply(item);
                  }
                }}
              >
                {couponLoadingId == item.coupons_id && couponLoadingId != null ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Loading...</span>
                  </>
                ) : (
                  "Apply"
                )}
              </button>
            )}
          </div>

          <div className="border_Bootam_Line mt-2"></div>

          {/* Coupon details */}
          <div>
            <h5 className="p-0 m-0 fs-14 ff-poppins-semiBold mt-1">
              {item?.coupons_name?.length > 25
                ? item?.coupons_name.slice(0, 25) + "..."
                : item?.coupons_name}
            </h5>
            <p className="fs-12 ff-poppins-medium primary-text p-0 m-0 mt-2">
              Required purchase value to redeem - <span className="rupeeIcon">₹</span>{item.min_pur_amount}
            </p>
          </div>

          {/* Read more toggle */}
          <div
            className="fs-12 ff-poppins-semiBold mt-3"
            onClick={() => {
              setCouponId(item.coupons_id);
              setShowDescription(
                couponId === item.coupons_id ? !showDescription : true
              );
            }}
          >
            {showDescription && couponId === item.coupons_id
              ? "- Read more"
              : "+ Read more"}
          </div>
        </div>
      </div>

      {/* Coupon description */}
      {showDescription && couponId === item.coupons_id && (
        <div className="couponDescription">
          <h5 className="fs-14 ff-poppins-semiBold">Coupon Description</h5>
          <p className="fs-10 ff-poppins-regular m-0 p-0 mt-1">
            {item.coupons_description}
          </p>
        </div>
      )}
    </div>
  );
};

export default CouponCard;